export default (theme: Object) => ({
  root: {
    marginBottom: -1,
    minHeight: 50,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      minHeight: 0,
    },
  },
  content: {
    [theme.breakpoints.down('sm')]: {
      margin: '6px 0',
    },
  },
  expansionPanelExpanded: {
    [theme.breakpoints.down('sm')]: {
      margin: '6px 0',
    },
  },
  expandIcon: {
    padding: 0,
  },
  panel: {
    overflow: 'hidden',
  },
  expansionPanelDetails: {
    padding: 0,
  },
  attributeName: {
    fontSize: 15,
    fontWeight: 600,
  },
});
